function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
  stroke: "none"
}, React.createElement("path", {
  d: "M3685 4341 c-77 -36 -145 -109 -174 -184 -21 -58 -21 -59 -21 -1087 l0 -1030 -62 34 c-111 61 -196 81 -333 80 -102 0 -132 -5 -200 -27 -111 -37 -196 -90 -279 -173 -132 -131 -195 -277 -204 -471 -6 -141 13 -231 76 -356 37 -75 62 -108 131 -177 138 -138 287 -200 481 -200 52 0 124 7 160 15 240 57 447 264 510 511 19 75 20 117 20 1416 0 904 3 1346 10 1359 10 18 24 19 303 19 258 0 296 2 327 18 103 51 108 201 8 262 -31 19 -51 20 -363 20 l-330 0 -60 -29z m-425 -2525 c300 -152 302 -575 2 -723 -70 -35 -83 -38 -161 -38 -76 0 -94 4 -153 32 -251 118 -312 440 -121 644 81 87 163 120 288 116 75 -3 99 -8 145 -31z"
}), React.createElement("path", {
  d: "M1943 3999 c-256 -24 -491 -216 -579 -474 -36 -107 -45 -280 -19 -388 73 -306 327 -523 634 -543 397 -26 731 297 731 706 0 197 -68 358 -210 500 -155 156 -334 219 -557 199z m172 -314 c146 -38 249 -152 281 -310 13 -60 14 -88 5 -136 -23 -135 -103 -244 -220 -302 -60 -29 -74 -32 -161 -32 -82 0 -103 4 -152 27 -161 75 -259 258 -230 427 29 162 136 286 282 325 72 19 123 19 195 1z"
}), React.createElement("path", {
  d: "M1780 2324 c-179 -32 -389 -118 -542 -222 -380 -259 -621 -698 -623 -1134 0 -132 1 -137 25 -163 53 -57 23 -55 753 -55 l674 0 34 23 c96 64 87 212 -15 261 -30 14 -99 16 -600 16 l-565 0 5 33 c45 259 161 477 347 654 224 212 513 315 837 298 101 -6 119 -4 150 12 38 21 80 90 80 133 0 46 -42 112 -85 134 -35 19 -60 21 -215 23 -121 1 -201 -3 -260 -13z"
}));

var SvgArtist = function SvgArtist(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArtist, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/artist.9064cf98.svg";
export { ForwardRef as ReactComponent };